import {Component, Input, TemplateRef, ViewChild, inject} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';
import {IxModule, ModalService} from '@siemens/ix-angular';

@Component({
  selector: 'app-detail',
  imports: [IxModule, TranslateModule],
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.scss',
})
export class DetailComponent {
  private readonly modalService = inject(ModalService);

  @Input({required: true}) attributes!: any;
  @Input({required: true}) label!: string;

  filteredAttributes!: string[][];

  @ViewChild('detailModal', {read: TemplateRef})
  detailModal!: TemplateRef<any>;

  async detailClick() {
    this.filteredAttributes = this.attributes.map((attr: any) =>
      Object.values(attr),
    );
    await this.modalService.open({
      content: this.detailModal,
      size: '480',
      data: {
        header: this.label,
      },
    });
  }

  onSearchChange(event: any) {
    this.filteredAttributes = this.attributes
      .map((attr: any) => Object.values(attr))
      .filter((attr: any) =>
        attr.some((value: string) => value.includes(event.target.value)),
      );
  }
}
